import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import AgentMap from "../components/Agents/AgentsMap";
import agentsActions from "../store/actions/agents";
import {Link} from 'react-router-dom';
import ModalContactAgent from "../components/Agents/ModalContactAgent";
import Slider from "react-slick";

const FindAnAgent = () => {
    const agentsStore = useSelector((store) => store.agentsStore);
    const dispatch = useDispatch();

    const [windowWidth, setWindowWidth] = useState(0);
    const [proximity, setProximity] = useState(25);
    const [proximityTooltip, setProximityTooltip] = useState(false);
    const [proximityTooltipShown, setProximityTooltipShown] = useState(false);

    let resizeWindow = () => {
        setWindowWidth(window.innerWidth);
    };

    const setSearchAddress = (input, address) => {
        dispatch(agentsActions.setSearchError(false));
        dispatch(agentsActions.setSearchAddress(address));
    };

    const setSearchName = (input, name) => {
        dispatch(agentsActions.setSearchError(false));
        dispatch(agentsActions.setSearchName(name));
    };

    const submitSearchAgents = (ev) => {
        ev.preventDefault();
        let isValid = true;
        if (!agentsStore.searchAddress && !agentsStore.searchName) {
            dispatch(agentsActions.setSearchError(true));
            isValid = false;
        }

        if (isValid) {
            setProximity(25);
            setProximityTooltip(false);
            setProximityTooltipShown(false);
            dispatch(
                agentsActions.fetchAgents(
                    agentsStore.searchAddress,
                    agentsStore.searchName,
                    25,
                    agentsStore.searchCount,
                    true
                ),
            );
        }
    };

    const changeProximity = (proximity) => {
        setProximity(proximity);
        setProximityTooltip(false);
        setProximityTooltipShown(true);
        dispatch(
            agentsActions.fetchAgents(
                agentsStore.lastSearchAddress,
                agentsStore.lastSearchName,
                proximity,
                agentsStore.searchCount,
                false
            ),
        );
    }

    const openContactModal = (agent) => {
        dispatch(agentsActions.setAgent(agent));
        dispatch(agentsActions.setModalOpen(true));
        document.getElementsByTagName('body')[0].classList.add('modal-open');
    }

    const modalSuccessClose = () => {
        dispatch(agentsActions.setModalSuccessOpen(false));
        document.getElementsByTagName('body')[0].classList.remove('modal-open');
    }

    const getPhones = (list) => {
        return list.map((phoneObj) => (
            <a key={phoneObj.id} href={`tel:${phoneObj.number}`} className="card__row-value phone">
                <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icons/phone-icon.svg`} alt=""/>
                {formatPhone(phoneObj.number)}
            </a>
        ));
    }

    const formatPhone = (phone) => {
        const numberArr = phone.split('');
        let numberInScopes = `${numberArr[0]}${numberArr[1]}${numberArr[2]}`;
        let numberFirstPart = `${numberArr[3]}${numberArr[4]}${numberArr[5]}`;
        let numberSecondPart = `${numberArr[6]}${numberArr[7]}${numberArr[8]}${numberArr[9]}`;
        return `(${numberInScopes}) ${numberFirstPart}-${numberSecondPart}`
    }

    const getAddress = (list) => {
        return list.map((address) => (
            <div key={address.id} className="card__row-value">
                {address.address}
            </div>
        ));
    }

    const agentAddresses = (agent) => {
        let addresses = false;
        if (agent.address && agent.address.length > 0) {
            addresses = getAddress(agent.address)
        }
        if (addresses) {
            return (
                <div className='card__contacts'>
                    <p className='card__row-name'>
                        Address
                    </p>
                    <div className="card__row-list">
                        {addresses}
                    </div>
                </div>
            )
        }

        return false
    }

    const agentPhones = (agent) => {
        let phones = false;
        if (agent.phones && agent.phones.length > 0) {
            phones = getPhones(agent.phones)
        }
        if (phones) {
            return (
                <div className='card__contacts'>
                    <p className='card__row-name'>
                        Phone
                    </p>
                    <div className="card__row-list">
                        {phones}
                    </div>
                </div>
            )
        }

        return false
    }

    const getAgentName = (agent) => {
        let agentName = '';
        if (agent.firstName) {
            agentName = agent.firstName
        }
        if (agent.middleName) {
            agentName = agentName + ' ' + agent.middleName
        }
        if (agent.lastName) {
            agentName = agentName + ' ' + agent.lastName
        }
        return agentName;
    }

    const getCompanyName = (agent) => {
        let agencyName = ''
        if (agent.agency && agent.agency.name !== getAgentName(agent)) {
            agencyName = agent.agency.name
        }
        return (
            <p className='card__text'>
                {agencyName}
            </p>
        )
    }

    const onHoverAgent = (agent) => {
        dispatch(agentsActions.setHoveredAgent(agent.agentKey))
    }

    const agentsList = agentsStore.agentsList.map((agent, key) => {
        return (
            <div key={agent.id} className='card' data-id={`agent${key + 1}`} onMouseOver={() => onHoverAgent(agent)}>
                <div className="card-block">
                    {agentsStore.searchByMap && (
                        <div className="card-block__number">{key + 1}</div>
                    )}
                    <div className='card__avatar'>
                        <div className='card__img'>
                            <img src={agent.image.webPath} alt=""/>
                        </div>
                        <Link
                            className='card__info-btn button-blue'
                            to={`/agent/${agent.id}`}
                            onClick={() => {dispatch(agentsActions.setAgent(agent))}}
                        >
                            More Info
                        </Link>
                    </div>
                    <div className='card__info-container'>
                        <div className='card__title-container'>
                            <div>
                                <h6 className='card__title'>
                                    {getAgentName(agent)}
                                </h6>
                                {getCompanyName(agent)}
                            </div>
                            <button
                                type='button'
                                className='card__email-btn button-gradient'
                                onClick={() => openContactModal(agent)}
                            >
                                Email Agent
                            </button>
                        </div>
                        {agentAddresses(agent)}
                        {agentPhones(agent)}
                    </div>
                </div>
            </div>
        )
    });

    let sliderRef = useRef(null);

    const settings = {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    useEffect(() => {
        resizeWindow();
        window.addEventListener("resize", resizeWindow);
        return () => {
            window.removeEventListener("resize", resizeWindow);
            setSearchAddress(null, '');
            setSearchName(null, '');
            dispatch(agentsActions.setAgentsList([]));
        }
    }, []);

    useEffect(() => {
        if (agentsStore.activeMarker && window.innerWidth >= 1024) {
            document.querySelector(`[data-id='agent${agentsStore.activeMarker}']`).scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "start"
            })
        } else if (agentsStore.activeMarker && window.innerWidth < 1024) {
            sliderRef.slickGoTo(agentsStore.activeMarker - 1)
        }
    }, [agentsStore.activeMarker]);

    useEffect(() => {
        if (agentsStore.noAgents && proximity === 25 && !agentsStore.isLoading && !proximityTooltipShown) {
            setProximityTooltip(true);
            setProximityTooltipShown(true);
            setTimeout(() => {
                setProximityTooltip(false);
            }, 10000)
        }
    }, [agentsStore.isLoading]);

    return (
        <div className='find-an-agent'>
            {agentsStore.modalOpen &&
                <ModalContactAgent/>
            }
            <div className="container">
                <div className="agent-search">
                    <div className="agent-search__header">
                        <h1 className='agent-search__title'>
                            Agent Search
                        </h1>
                        <img
                            src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/agent-dialog-376.png`}
                        />
                    </div>
                    <p className='agent-search__text'>
                        Find an insurance professional near{'\u00A0'}you
                    </p>
                    <form className='form agent-search__form' onSubmit={(ev) => submitSearchAgents(ev)}>
                        <div className="form-group input-address">
                            <input
                                placeholder='City Name or Zip Code'
                                className={`form-input ${agentsStore.searchError && 'error'}`}
                                onInput={(ev) => setSearchAddress(ev, ev.target.value)}
                                value={agentsStore.searchAddress}
                            />
                        </div>
                        <div className="form-group input-name">
                            <input
                                placeholder='Agent Name'
                                className={`form-input ${agentsStore.searchError && 'error'}`}
                                onInput={(ev) => setSearchName(ev, ev.target.value)}
                                value={agentsStore.searchName}
                            />
                        </div>
                        <button
                            className={`form-submit button-gradient ${agentsStore.isLoading && 'is-loading'}`}
                            type='submit'
                        >
                            <span>Search</span>
                        </button>
                    </form>
                    {agentsStore.searchError &&
                        <div className="agent-search__error">You should enter either Agent Name and/or City or Zip Code</div>
                    }
                </div>
                {agentsStore.searchByMap ? (
                    <div className="search-by-map">
                        <div className="search-results">
                            <h2 className='search-results__title'>
                                Insurance professionals near you
                            </h2>
                            <div className={`search-results__container ${agentsStore.isLoading ? 'is-loading' : ''} ${agentsList.length ? '' : 'no-results'}`}>
                                <div className="search-results__map">
                                    <fieldset className="search-proximity">
                                        <div className={`search-proximity-tooltip ${proximityTooltip ? 'is-shown' : ''}`}>
                                            Try changing the search radius
                                        </div>
                                        <label className="custom-radio">
                                            <input type="radio" name="proximity" value="25"
                                                   onChange={() => changeProximity(25)}
                                                   checked={proximity === 25}/>
                                            <div className={`custom-radio__button ${proximity === 25 && 'checked'}`}>25 miles</div>
                                        </label>
                                        <label className="custom-radio">
                                            <input type="radio" name="proximity" value="50"
                                                   onChange={() => changeProximity(50)}
                                                   checked={proximity === 50}/>
                                            <div className={`custom-radio__button ${proximity === 50 && 'checked'}`}>50 miles</div>
                                        </label>
                                        <label className="custom-radio">
                                            <input type="radio" name="proximity" value="75"
                                                   onChange={() => changeProximity(75)}
                                                   checked={proximity === 75}/>
                                            <div className={`custom-radio__button ${proximity === 75 && 'checked'}`}>75 miles</div>
                                        </label>
                                    </fieldset>
                                    <div className="search-results__map-wrapper">
                                        <AgentMap/>
                                    </div>
                                </div>
                                <div className="search-results__list">
                                    <h6 className='search-results__total-text'>
                                        {`Total: ${agentsList.length} Agents`}
                                    </h6>
                                    <div className={`search-no-results ${agentsStore.noAgents ? '' : 'hidden'}`}>
                                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/loop.svg`}/>
                                        <div className="search-no-results__title">Sorry, no results were found</div>
                                        <div className="search-no-results__subtitle">Please adjust your search criteria or change your <span className="nowrap">search radius and try again.</span></div>
                                    </div>
                                    {windowWidth < 1024 ? (
                                        <div className="agents-list-slider">
                                            <Slider ref={slider => (sliderRef = slider)} {...settings}>
                                                {agentsList}
                                            </Slider>
                                        </div>
                                    ) : (
                                        <div className="agents-list">
                                            {agentsList}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="search-no-map">
                        <div className={`search-no-results ${agentsStore.noAgents ? '' : 'hidden'}`}>
                            <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/loop.svg`}/>
                            <div className="search-no-results__title">Sorry, no results were found</div>
                            <div className="search-no-results__subtitle">Please adjust your search criteria <span className="nowrap">and try again.</span></div>
                        </div>
                        <div className={`search-results ${agentsStore.agentsList.length > 0 ? '' : 'hidden'}`}>
                            <h2 className='search-results__title'>
                                Insurance professionals near you
                            </h2>
                            <div className={`search-results__container no-map ${agentsStore.isLoading ? 'is-loading' : ''}`}>
                                <div className="search-results__list">
                                    <h6 className='search-results__total-text'>
                                        {`Total: ${agentsList.length} Agents`}
                                    </h6>
                                    {windowWidth < 1024 ? (
                                        <div className="agents-list-slider">
                                            <Slider ref={slider => (sliderRef = slider)} {...settings}>
                                                {agentsList}
                                            </Slider>
                                        </div>
                                    ) : (
                                        <div className="agents-list">
                                            {agentsList}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className={`modal-success ${agentsStore.modalSuccessOpen ? 'open' : ''}`}>
                <div className="modal-success-container">
                    <button type="button" className="button-close" onClick={() => modalSuccessClose()}>
                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/find-an-agent/close.svg`} alt="close"/>
                    </button>
                    <img className="modal-success-image" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/contact-us/icon-success.svg`}/>
                    <div className="modal-success-title">Done!</div>
                    <div className="modal-success-text">Your message has been sent.</div>
                    <button className="modal-success-btn button-gradient" onClick={() => modalSuccessClose()}>Back To Agent Search</button>
                </div>
            </div>
        </div>
    )
};

export default FindAnAgent;

